module.exports = __webpack_public_path__ + "static/member05-8ce3233838b21a6a83b0524f83b756f6.png";